import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/take';
import { ENV } from '@app/env';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { switchMap, map } from 'rxjs/operators';
import { isEmpty } from 'lodash';

@Injectable()
export class MessageData {

  constructor(
    private afdb: AngularFireDatabase,
    private afs: AngularFirestore
  ) { }

  /*** GENERAL */

  public getClientFooterMessageActive() {
    return this.afdb.list(`/Clients/${ENV.client}/Interactivity/Footer`, ref => {
      return ref.orderByChild('state').equalTo(true);
    }).valueChanges();
  }

  public getClientAlertMessageActive() {
    return this.afdb.list(`/Clients/${ENV.client}/Interactivity/Alert`, ref => {
      return ref.orderByChild('state').equalTo(true);
    }).valueChanges();
  }

  public getClientToastMessageActive() {
    return this.afdb.list(`/Clients/${ENV.client}/Interactivity/Toast`, ref => {
      return ref.orderByChild('state').equalTo(true);
    }).valueChanges();
  }

  public userClientHasViewMessage(type: 'Alert' | 'Toast', messageId: string, userId: string) {
    return this.afs.collection(ENV.client).doc('messages-views').collection(type, ref => {
      return ref.where('userId', '==', userId).where('messageId', '==', messageId).limit(1);
    }).valueChanges()
      .pipe(map((views) => {
        return !isEmpty(views);
      }))
  }

  public saveClientMessageView(type: 'Alert' | 'Toast', messageId: string,
    userId: string): Observable<any> {
    let id = this.afdb.createPushId();
    return Observable.fromPromise(this.afs.collection(ENV.client).doc('messages-views').collection(type)
      .doc(<string>id).set({
        id: id,
        type: type,
        create_at: firebase.firestore.FieldValue.serverTimestamp(),
        messageId: messageId,
        userId: userId
      }))
  };

  public saveClientMessageStatistic(type: 'Alert' | 'Toast', messageId: string) {
    return Observable.fromPromise(this.afdb.object(`/Clients/${ENV.client}/stats/messages/${type}/${messageId}`)
      .query.ref.transaction((messageStats) => {
        if (messageStats) {
          return messageStats + 1;
        } else {
          return 1
        }
      }));
  }

  public saveClientStatisticAndView(type: 'Alert' | 'Toast', messageId: string,
    userId: string) {
    return this.saveClientMessageStatistic(type, messageId)
      .pipe(switchMap(() => {
        return this.saveClientMessageView(type, messageId, userId)
      }))
  }

  /** EVENT */

  public getEventAlertMessageActive(eventId: string) {
    return this.afdb.list(`/Clients/${ENV.client}/Events/${eventId}/Messages/Alert`, ref => {
      return ref.orderByChild('state').equalTo(true);
    }).valueChanges();
  }

  public getEventToastMessageActive(eventId: string) {
    return this.afdb.list(`/Clients/${ENV.client}/Events/${eventId}/Messages/Toast`, ref => {
      return ref.orderByChild('state').equalTo(true);
    }).valueChanges();
  }

  public userEventHasViewMessage(eventId: string, type: 'Alert' | 'Toast', messageId: string, userId: string) {
    return this.afs
      .collection(ENV.client)
      .doc('messages-views-events')
      .collection('event')
      .doc(eventId)
      .collection(type, ref => ref.where('userId', '==', userId).where('messageId', '==', messageId).limit(1))
      .valueChanges()
      .pipe(map((views) => {
        return !isEmpty(views);
      }))
  }

  public saveEventMessageView(eventId: string, type: 'Alert' | 'Toast', messageId: string,
    userId: string): Observable<any> {
    let id = this.afdb.createPushId();
    return Observable.fromPromise(this.afs.collection(ENV.client).doc('messages-views-events').collection('event').doc(eventId).collection(type)
      .doc(<string>id).set({
        id: id,
        type: type,
        create_at: firebase.firestore.FieldValue.serverTimestamp(),
        messageId: messageId,
        userId: userId
      }))
  }

  public saveEventMessageStatistic(eventId: string, type: 'Alert' | 'Toast', messageId: string) {
    return Observable.fromPromise(this.afdb.object(`/Clients/${ENV.client}/Events/${eventId}/stats/messages/${type}/${messageId}`)
      .query.ref.transaction((messageStats) => {
        if (messageStats) {
          return messageStats + 1;
        } else {
          return 1
        }
      }));
  }

  public saveEventStatisticAndView(eventId: string, type: 'Alert' | 'Toast', messageId: string,
    userId: string) {
    return this.saveEventMessageStatistic(eventId, type, messageId)
      .pipe(switchMap(() => {
        return this.saveEventMessageView(eventId, type, messageId, userId)
      }))
  }
}


// WEBPACK FOOTER //
// ./src/providers/messages.ts